import { useTranslation } from "react-i18next";
import { AsyncState } from "@evergis/react-fetching/es/hooks/useAsyncState";
import { BulkOperationResultDc } from "@evergis/api/dist/__generated__/data-contracts";

import { useNotification } from "../../../../hooks/notifications/useNotification";

export const useAccessNotifications = (updateState: AsyncState<BulkOperationResultDc[], unknown>) => {
  const { t } = useTranslation("dialogs");
  const { data: updateResult, loading: updateLoading, error: updateError } = updateState;

  useNotification(!!updateResult && !updateLoading && updateResult.every(item => item.isSuccess), {
    error: false,
    title: t("access.changesApplySuccess"),
  });

  useNotification(!updateLoading && (updateError || updateResult?.some(item => !item.isSuccess)), {
    error: true,
    title: t("access.changesApplyError"),
  });
};
